import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, url, image }) => {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="author" content="Juan Carlos Mancha Ramos" />
      <meta name="robots" content="index, follow" />
      <meta name="generator" content="React" />

      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />

      {/* Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Juan Carlos Mancha Ramos",
          "jobTitle": "Desarrollo Web, E-Commerce y Marketing Digital",
          "image": image,
          "url": url,
          "areaServed": "Córdoba, Argentina",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Córdoba",
            "addressCountry": "Argentina"
          },
          "email": "info@juancarlosmancharamos.ar"
        })}
      </script>
    </Helmet>
  );
};

export default SEO;